import { DateRangeDropdownV2, DocumentNumberRangeFieldV2, FormFieldV2, SearchFieldV2 } from '@/components/custom/erp';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  account?: AccountModel;
  setAccount?: (account: AccountModel) => void;
}

const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ account, setAccount }) => {
  return (
    <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
      <div className='space-y-3 p-4'>
        {/* Ngày chứ từ/đến */}
        <div className='flex items-center'>
          <Label className='flex min-w-[150px] items-center pr-2 text-left text-[13px] font-normal sm:mb-0'>
            Ngày c/từ(từ/đến)
          </Label>
          <DateRangeDropdownV2 fromDateName='fromDate' toDateName='toDate' />
        </div>

        {/* Số chứ từ/đến */}
        <div className='flex items-center'>
          <DocumentNumberRangeFieldV2 fromName='voucherNumberStart' toName='voucherNumberEnd' />
        </div>

        {/* Loại xuất */}
        <div className='flex items-center'>
          <Label className='flex min-w-[150px] items-center pr-2 text-left text-[13px] font-normal sm:mb-0'>
            Loại xuất
          </Label>
          <FormFieldV2
            name='exportType'
            type='select'
            className='w-[200px]'
            options={[
              { value: '0', label: 'Tất cả' },
              { value: '1', label: '1. Theo hóa đơn' },
              { value: '2', label: '2. Theo khách hàng' }
            ]}
          />
        </div>

        {/* Tài khoản nợ */}
        <div className='flex items-center'>
          <Label className='flex min-w-[150px] items-center pr-2 text-left text-[13px] font-normal sm:mb-0'>
            Tài khoản nợ
          </Label>
          <SearchFieldV2<AccountModel>
            type='text'
            displayRelatedField='name'
            columnDisplay='code'
            className='w-[11.25rem]'
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
            searchColumns={accountSearchColumns}
            dialogTitle='Danh mục tài khoản'
            value={account?.code || ''}
            relatedFieldValue={account?.name || ''}
            onRowSelection={setAccount}
          />
        </div>

        {/* Diễn giải */}
        <div className='flex items-center'>
          <Label className='flex min-w-[150px] items-center pr-2 text-left text-[13px] font-normal sm:mb-0'>
            Diễn giải
          </Label>
          <FormFieldV2 name='description' type='text' className='w-96' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
